import { render, staticRenderFns } from "./lost-package-edit.vue?vue&type=template&id=1540b6a4&"
import script from "./lost-package-edit.vue?vue&type=script&lang=js&"
export * from "./lost-package-edit.vue?vue&type=script&lang=js&"
import style0 from "./lost-package-edit.vue?vue&type=style&index=0&id=1540b6a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports